import { apiInstance } from "@core/api/axios/apiInstance";
import { partnerApplySchema, type PartnerApplyType } from "@features/auth/model/partnerModel";
import { parseSchema } from "@core/model/parseSchema";

export const fetchPartnerApply = async (iCafeId: string) => {
  const res = await apiInstance.post(`/icafe/smart/${iCafeId}`);
  return parseSchema<PartnerApplyType>({
    schema: partnerApplySchema,
    rawData: res?.data,
  });
};
